import { memo, useState } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// Local files
import { StyledListItem } from './Item.styled';
import SuperbillTaskDialog from 'components/Dialogs/SuperbillTask/SuperbillTask';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const Item = ({ id, superbill_goal, result, status, updated_at }) => { 
  const [superbillTaskDialog, setSuperbillTaskDialog] = useState({ open: false, taskId: '' });
  const date = new Date(updated_at).toLocaleDateString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
  
  const handleCreate = () => setSuperbillTaskDialog({ open: true, taskId: id });
  const handleClose = () => setSuperbillTaskDialog({ open: false, taskId: '' });

  return (
    <>
      <SuperbillTaskDialog {...superbillTaskDialog} onClose={handleClose} />
      <StyledListItem disablePadding>
        <Box sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <Typography variant='subtitle2' noWrap>{`Clinician: ${superbill_goal.clinician.first_name} ${superbill_goal.clinician.last_name}`}</Typography>
          <Typography variant='subtitle2' noWrap>{`Email: ${superbill_goal.email ?? '-'}`}</Typography>
          {!!result && <Typography variant='subtitle2' noWrap>{`Result: ${result.filename ?? '-'}`}</Typography>}
          <Typography variant='subtitle2' noWrap>Status: {status}</Typography>
          <Typography variant='subtitle2' noWrap>{date}</Typography>
        </Box>
        <Button variant='contained' onClick={handleCreate} sx={{ mr: 1 }}>View</Button>
      </StyledListItem>
    </>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Item {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);